import React from 'react';
import { motion } from 'framer-motion';
import { Globe, LineChart } from 'lucide-react';

const VisionMission = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-16">
          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative p-8 rounded-xl bg-gradient-to-br from-gray-800 to-gray-700 backdrop-blur-sm border border-gray-600 hover:border-gray-500 transition-all duration-300"
          >
            <div className="relative">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
                  <Globe className="w-6 h-6 text-accent" />
                </div>
                <h2 className="text-2xl md:text-3xl font-display font-semibold text-white">
                  Our Vision
                </h2>
              </div>
              <h3 className="text-xl text-white mb-4">
                Leading the Future of Digital Transformation
              </h3>
              <p className="text-gray-300">
                To connect people and organizations through innovative technology, creating a sustainable and digitally advanced future.
              </p>
            </div>
          </motion.div>

          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative p-8 rounded-xl bg-gradient-to-br from-gray-800 to-gray-700 backdrop-blur-sm border border-gray-600 hover:border-gray-500 transition-all duration-300"
          >
            <div className="relative">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
                  <LineChart className="w-6 h-6 text-accent" />
                </div>
                <h2 className="text-2xl md:text-3xl font-display font-semibold text-white">
                  Our Mission
                </h2>
              </div>
              <h3 className="text-xl text-white mb-4">
                Delivering Business Value Through Technology
              </h3>
              <p className="text-gray-300">
                We craft high-quality digital solutions by blending advanced technology with intuitive user experiences, empowering businesses to stay ahead.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;